import React, { useEffect, useRef, useState } from "react";
import Accordion from "../Accordion";
import { useQuery } from "@apollo/client";
import { QUERY_GET_CMS_BLOCKS } from "~/data/home";
import { Identifiers } from "~/constants/enum";
import parse from "html-react-parser";

type Props = {};

const FAQ = (props: Props) => {
  const faqRef = useRef<any>();
  const { data, loading } = useQuery(QUERY_GET_CMS_BLOCKS, {
    variables: {
      identifiers: [Identifiers.FAQProduct],
    },
  });
  const [arrcodingData, setArrcodingData] = useState<any>([]);

  const initAccordion = () => {
    setTimeout(() => {
      const accordionItems: any =
        faqRef?.current?.getElementsByClassName("accordion__item");
      const ArrayArrcoding = [];
      for (let index = 0; index < accordionItems?.length; index++) {
        const element = accordionItems[index];
        const question: any =
          element?.getElementsByClassName("accordion__button")?.[0]?.innerHTML;
        if (!!question) {
          const panels: any =
            element?.getElementsByClassName("accordion__panel")?.[0];
          ArrayArrcoding.push({
            label: question,
            content: <div>{!!panels ? parse(panels?.innerHTML) : ""}</div>,
            key: index,
          });
        }
      }
      setArrcodingData(ArrayArrcoding);
    }, 100);
  };

  useEffect(() => {
    initAccordion();
  }, [data?.cmsBlocks?.items?.[0].content]);

  return (
    <div className="px-2">
      <div
        ref={faqRef}
        className="hidden"
        dangerouslySetInnerHTML={{
          __html: data?.cmsBlocks?.items?.[0].content,
        }}
      />
      <Accordion className="pb-5" items={arrcodingData} defaultActive={[]} />
    </div>
  );
};

export default FAQ;
